<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import columns from '@/pages/digitize/columns';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import ChangeProduct from '@/components/modals/Change-product.vue';
import DigitizeWizard from '@/components/wizards/digitize/Digitize-wizard.vue';
import CreateDigitizeLink from '@/components/modals/Create-digitize-link.vue';

const b = bem('digitize-page');
export default {
  data() {
    return {
      productInfo: {},
      productColumns: [],
      columns: columns(),
      title: '',
      selectedId: null,
      isShow: false,
      isShowNew: false,
      isShowWizard: true,
      isCreateLink: false,
      typeProduct: null,
    };
  },
  mounted() {
    this.getProductsAction('digitize');
  },
  components: {
    PageHeader,
    ChangeProduct,
    DownOutlined,
    UpOutlined,
    DigitizeWizard,
    CreateDigitizeLink,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getProductsAction: 'products/getProducts',
      updateProductAction: 'products/updateProduct',
      deleteProductAction: 'products/deleteProduct',
      updateOptionPositionsAction: 'products/updateOptionPositions',
    }),
    ...mapGetters({
      productInfoGet: 'products/filteredProduct',
    }),
    ...mapState({
      isProductsLoaded: (state) => state.products.isProductsLoaded,
    }),
    onUpdate(value) {
      const newValue = {
        id: value.id,
        displayName: value.displayName,
        displayText: value.displayText,
        disclaimer: value.disclaimer,
        price: value.price,
        additionalDiscount: value.additionalDiscount,
        isTaxApplied: value.isTaxApplied,
        isToggle: value.isToggle,
        isMainOption: value.isMainOption,
        visible: value.visible,
        dependQuantityProductIds: value.dependQuantityProductIds,
        type: 'digitize',
      };
      this.updateProductAction(newValue);
    },
    onDelete(value) {
      this.deleteProductAction({
        id: value,
        type: 'digitize',
      });
    },
    showModal(record) {
      this.selectedId = record.id;
      this.isShow = true;
    },
    showNewModal() {
      this.isShowNew = true;
    },
    showWizardToggle() {
      this.isShowWizard = !this.isShowWizard;
    },
    openCreateLinkPopup() {
      this.isCreateLink = true;
    },
    changePosition(currentValue, replaceValue) {
      this.updateOptionPositionsAction({
        type: 'digitize',
        changePosition: [currentValue, replaceValue],
      });
    },
    getFlatProducts(value) {
      const { options, ...rest } = value;
      const sortedOptions = options.sort((a, c) => a.index - c.index);
      return [rest, ...sortedOptions];
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.products.isLoading,
      isProductsLoaded: (state) => state.products.isProductsLoaded,
    }),
  },
  watch: {
    isProductsLoaded(newValue, oldValue) {
      if (!oldValue && newValue) {
        const { type } = this.$route.params;
        this.typeProduct = type;
        const product = this.productInfoGet()(type);
        const foreverProduct = this.productInfoGet()('forever_cloud');
        this.productInfo = product;
        const flatMainProducts = this.getFlatProducts(product);
        const flatCloudProducts = type !== 'forever_cloud' ? this.getFlatProducts(foreverProduct) : [];
        this.productColumns = [...flatMainProducts, ...flatCloudProducts];
        this.title = type.charAt(0).toUpperCase() + type.slice(1).replaceAll('_', ' ');
      }
    },
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div :class="b()">
    <div :class="b('button', { new: true })">
      <a-button v-if="!isShowWizard" type="primary" @click="showNewModal()">
        Create new
      </a-button>
      <ChangeProduct
        v-if="isShowNew"
        v-model:show="isShowNew"
        :isShow="isShowNew"
        :full-product="productInfo"
        :isNewProduct="true"
        button-text="Create"
        title="Create product"
        type="digitize"
      />
    </div>
    <div :class="b('product-info')" v-if="!isShowWizard">
      <a-table
          :columns="columns"
          :data-source="productColumns"
          :pagination="false"
      >
        <template #bodyCell="{ column, text, record, index }">
          <template v-if="column.dataIndex === 'isTaxApplied'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isTaxApplied: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'isToggle'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isToggle: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'isMainOption'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isMainOption: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'visible'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, visible: !text})">
            </a-switch>
          </template>
          <template v-else-if="column.dataIndex === 'actions'">
            <div :class="b('buttons')">
              <div :class="b('order-buttons')">
                <div :class="b('button', { arrow: true })" v-if="index > 1">
                  <a-button
                      type="primary"
                      size="small"
                      @click="changePosition(
                          { id: record.id, index: index - 1 },
                          { id: productColumns[index - 1].id, index },
                      )"
                  >
                    <template #icon>
                      <UpOutlined />
                    </template>
                  </a-button>
                </div>
                <div
                    :class="b('button', { arrow: true })"
                    v-if="index !== productColumns.length - 1 && index !== 0"
                >
                  <a-button
                      type="primary"
                      size="small"
                      @click="changePosition(
                          { id: record.id, index: index + 1 },
                          { id: productColumns[index + 1].id, index },
                      )"
                  >
                    <template #icon>
                      <DownOutlined />
                    </template>
                  </a-button>
                </div>
              </div>
              <div :class="b('button')">
                <a-button type="primary" @click="showModal(record)">
                  Edit
                </a-button>
                <div v-if="isShow && selectedId === record.id">
                  <ChangeProduct
                      v-model:show="isShow"
                      :isShow="isShow && selectedId === record.id"
                      :product="record"
                      :full-product="productInfo"
                      :isNewProduct="false"
                      button-text="Edit"
                      title="Change product"
                      type="digitize"
                  />
                </div>
              </div>
              <div :class="b('button')">
                <a-popconfirm title="Sure to delete?" @confirm="onDelete(record.id)">
                  <a-button type="primary" html-type="button" danger>
                    Delete
                  </a-button>
                </a-popconfirm>
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
    <div :class="b('wizard')" v-else>
      <DigitizeWizard
        :product-name="$route.params.type"
        :products="productColumns"
      />
    </div>
    <div :class="b('top-buttons')">
      <a-button type="primary" @click="showWizardToggle()">
        {{ isShowWizard ? 'Product info' : 'Product wizard' }}
      </a-button>
      <div v-if="isShowWizard">
        <a-button type="primary" @click="openCreateLinkPopup()">
          {{ 'Create link' }}
        </a-button>
        <div v-if="isCreateLink && typeProduct && productColumns && productColumns.length">
          <CreateDigitizeLink
            v-model:show="isCreateLink"
            :productName="typeProduct"
            :products="productColumns"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
